module.exports = __webpack_public_path__ + "img/swiper-6.8f997401.png";